import * as React from "react";
import { memo } from "react";

const SvgMonitor = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.455 0A.454.454 0 0 0 0 .455v9.943c0 .25.203.454.455.454h9.093v2.016H5.302a.454.454 0 1 0 0 .91H14.7a.455.455 0 1 0 0-.91h-4.243v-2.016h9.089a.454.454 0 0 0 .454-.454V.455A.454.454 0 0 0 19.546 0H.454Zm.454.909h18.182v9.034H.91V.91Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgMonitor);
export default Memo;
